import { Text, View } from '@react-pdf/renderer';

import { usePDFContext } from '../../PDFProvider';
import { styles } from './styles';

export function EmployeeInformation() {
  const { user, csrName, csrEmail } = usePDFContext();

  return (
    <View style={[styles.row]}>
      <View style={styles.fullRow}>
        <Text>Quoted By:</Text>
        <Text>
          {user.firstName} {user.lastName}
        </Text>
        <Text>{user.email}</Text>
      </View>

      {csrName && csrEmail ? (
        <View style={styles.fullRow}>
          <Text>Customer Service:</Text>
          <Text>{csrName}</Text>
          <Text>{csrEmail}</Text>
        </View>
      ) : null}
    </View>
  );
}
